import { createI18n } from 'vue-i18n'

const urlParams = new URLSearchParams(window.location.search);
let lang = urlParams.get('lang');
try {
    if (lang) {
        localStorage.setItem('lang', lang)
    }
    if (!lang) {
        lang = localStorage.getItem('lang')
    }
} catch (e) {

}

const locales = ['ru', 'en', 'bn', 'az', 'es', 'uz', 'ko', 'ky', 'tg', 'tr'];
let messages = {} as any
for (const locale of locales) {
    messages[locale] = require(`@/i18n/messages.${locale}.json`)
}
const i18n = createI18n({
    legacy: false,
    locale: lang ? (locales.includes(lang.toLowerCase()) ? lang.toLowerCase() : 'ru') : 'ru',
    fallbackLocale: 'en',
    messages
})

export default i18n